export enum ContactStatus {
  BUYER = "Buyer",
  PROSPECT = "Prospect",
}
